import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setCreatorType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const CreatorTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Creator Type"
      id="creator_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCreatorType(option.id))
      }}
    />
  )
}
export default CreatorTypeDropdown
